var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.157 4.343C13.033 1.219 7.967 1.219 4.843 4.343C1.719 7.467 1.719 12.533 4.843 15.657C7.967 18.781 13.033 18.781 16.157 15.657C19.281 12.533 19.281 7.467 16.157 4.343ZM11.5 14.243C11.5 14.796 11.053 15.243 10.5 15.243C10.224 15.243 9.974 15.131 9.793 14.95C9.612 14.769 9.5 14.518 9.5 14.243V11H6.257C5.981 11 5.731 10.888 5.55 10.707C5.369 10.526 5.258 10.276 5.258 10C5.258 9.447 5.705 9 6.258 9H9.5V5.757C9.5 5.204 9.947 4.757 10.5 4.757C11.053 4.757 11.5 5.204 11.5 5.757V9H14.743C15.296 9 15.743 9.447 15.743 10C15.743 10.553 15.296 11 14.743 11H11.5V14.243Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.14562c563bb09773a1737233bf6a380a.svg";
export { ForwardRef as ReactComponent };